export enum LandingTypeEnum {
  EXTERNAL = "EXTERNAL",
  INTERIOR = "INTERIOR"
}